<template>
  <div ref="content" class="alert-content">
    <div class="alert-content-btns">
      <div><button class="alert-content-btn" @click="toggleContent()" v-if="!showFullContent">show more</button></div>
      <div><button class="alert-content-btn" @click="toggleContent()" v-if="showFullContent">show less</button></div>
      <div><button class="alert-content-btn" @click="scrollToHit()" v-if="showFullContent && !loadingContent">scroll to hit</button></div>
    </div>
    <pre v-html="alertContent"></pre>
  </div>
</template>


<style>
.alert-content-hit {
  font-weight: bold;
}
.alert-content-hit-highlight {
  background: #ff6666;
}
</style>
<style scoped>
.alert-content {
  font-size: 10px;
  border: 1px solid wheat;
  border-radius: 3px;
  margin-top: 5px;
  overflow-y: auto;
  max-height: 400px;
}
.alert-content-btns {
  float: right;
  text-align: right;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  z-index:1;
  top: 0;
}
.alert-content-btn {
  margin: 2px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Alert',
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  computed: {
    alertContent () {
      var hitId = 'hit-' + this.alert.id
      var hitStartTag = '{'+hitId+'-start}'
      var hitEndTag = '{'+hitId+'-end}'
      // Add hit tags before sanitizing in order to avoid possible modifications to value text
      var content = this.alert.content
      var hitStartIdx = this.alert.index
      var hitEndIdx = hitStartIdx + this.alert.value.length
      if (this.alert.content_full && this.showFullContent) {
        content = this.alert.content_full
        hitStartIdx = this.alert.index + this.alert.offset
        hitEndIdx = hitStartIdx + this.alert.value.length
      }
      content = this.addHitTags(content, hitStartIdx, hitEndIdx, hitStartTag, hitEndTag)
      // Sanitize possible HTML content
      content = content.replace(new RegExp('&', 'g'), '&amp;')
      content = content.replace(new RegExp('<', 'g'), '&lt;')
      content = content.replace(new RegExp('>', 'g'), '&gt;')
      // Replace hit tags
      if (this.showFullContent)
        content = content.replace(new RegExp(hitStartTag, 'g'), '<span id="' + hitId + '" class="alert-content-hit-highlight">')
      else
        content = content.replace(new RegExp(hitStartTag, 'g'), '<span id="' + hitId + '" class="alert-content-hit">')
      content = content.replace(new RegExp(hitEndTag, 'g'), '</span>')
      return content
    },
    ...mapState([
      'debugMode',
      'apiAccount'
    ])
  },
  methods: {
    addHitTags (content, startIdx, endIdx, startTag, endTag) {
      var highlightedContent = content.slice(0, startIdx)
      highlightedContent += startTag + content.slice(startIdx, endIdx) + endTag
      highlightedContent += content.slice(endIdx)
      return highlightedContent
    },
    toggleContent () {
      //Fetch full content if not already existing
      if (!this.alert.content_full){
        this.loadFullContent()
      }
      this.showFullContent = !this.showFullContent
      if (!this.showFullContent)// Scroll to hit if full content is being hidden so the alert becomes visible
        this.$nextTick(this.scrollToHit)
    },
    loadFullContent () {
      this.apiAccount.get('/alerts/' + this.alert.id).then(alert => {
        if (alert.content_full) {
          this.alert.content_full = alert.content_full
        } else {
          this.alert.content_full = 'Full content not available'
        }
        this.loadingContent = false
      })
      this.loadingContent = true
      this.alert.content_full = 'Loading...'
    },
    scrollToHit () {
      // console.log(this.$refs)
      var content = this.$refs.content
      var hit = content.querySelector('#hit-' + this.alert.id)
      content.scrollTop = hit.offsetTop - content.offsetTop - 100
    }
  },
  data () {
    return {
      loadingContent: false,
      showFullContent: false,
    }
  },
}
</script>
